@if (messageService.isVisible()) {
  <nx-message
    [@messageAnim]="messageService.isVisible()"
    [context]="messageService.type()"
    closable="true"
    (close)="messageService.hide()"
  >
    @if (isArray() && messageService.text().length > 1) {
      @for (item of messageService.text(); track $index) {
        <li>{{ item }}</li>
      }
    } @else if (isArray()) {
      {{ messageService.text()[0] }}
    } @else {
      {{ messageService.text() }}
    }

    @if (messageService.traceId()) {
      <small class="absolute bottom-0 left-16 text-sm text-[#757575] font-light">
        {{ messageService.traceId() }}
      </small>
    }
  </nx-message>
}
